<template>
  <div
    class="rounded-xl bg-white/10 backdrop-blur px-6 pt-6 pb-4 hover:scale-[1.02]
           transition border border-white/10
           grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6 content-between "
  >
    <div>
      <img
        :src="image ? image : '/images/logo_url.png'"
        onerror="this.onerror=null; this.src='/images/logo_url.png'"
        alt="Url Image"
        loading="lazy"
        style="background-color: white;"
        class="aspect-video w-full h-32 w-64 object-cover rounded-lg object-contain m-auto"
      />
    </div>
    <div class1="relative h-32">
      <h3 :title="title" class="font-semibold text-lg overflow-hidden text-ellipsis">{{ title }}</h3>
      <p :title="description" class="text-sm text-white/70 mt-2 overflow-hidden text-ellipsis">{{ description }}
      </p>
      <div class="inline-flex flex-wrap mt-2" v-if="tags">
        <span v-for="tag in tags" :key="tag" class="inline-flex items-center py-1 px-3 me-2 rounded-full text-xs font-medium border border-line-8 text-foreground hover:bg-cyan-400 hover:text-black">{{ tag }}</span>
      </div>
      <div class="flex justify-stretch">
        <a target="_blank" :href="'/redirect/'+encodeURIComponent(url)" :title="'Go to: ' + url"
           class="flex-none text-sm overflow-hidden mt-3 text-ellipsis content-center">{{ url }}
        </a>
        <a target="_blank" :title="'Go to: ' + url" :href="'/redirect/'+encodeURIComponent(url)"
           class="flex-none text-sm overflow-hidden text-ellipsis hover:bg-white/10 mt-2 ms-2 ps-1 pt-2 rounded">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
        </a>
        <div class="flex-1"></div>

        <!-- Share -->
        <!-- <div class="relative inline-block pt-1" ref="popoverRef"> -->
          <!-- Botão -->
          <!-- <button target="_blank" @click="toggle" :title="'Share: ' + url"
            ref="btnRef"
            class="flex-none text-sm overflow-hidden text-ellipsis content-center hover:bg-white/10 mt-2 ps-1 pt-1 rounded">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30" stroke-width="1.5" stroke="currentColor" class="size-6">
               <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
            </svg>
          </button>
          <Teleport to="body"> -->

            <!-- Popover -->
            <!-- <div v-if="open" :style="style"
                class="fixed z-[9999] bg-[#1E1243] rounded-lg shadow-lg ">
                
              <button
                v-for="option in options"
                :key="option.value"
                target="_blank"
                @click="select(option)"
                class="block w-full px-4 py-2 text-left hover:bg-gray-100 text-white flex text hover:text-black">
                <span class="pt-1 me-2" v-html="option.image"></span>
                <span>{{ option.label }}</span>
              </button>
            </div>
          </Teleport>
        </div> -->
        <!-- End Dropdown -->

      </div>

        <!-- likes -->
        <!-- <span class="absolute top-2 right-2 p-1">
          <button type="button" class="hover:bg-white
                                        shadow rounded-xl size-6
                                        flex items-center justify-center
                                        transition"
                      @click="like(index)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  class="size-4 fill-white hover:fill-red-500 hover:size-6">
              <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
            </svg>

          </button>
          <button type="button" class="hover:bg-red-500
                                        shadow rounded-xl size-6
                                        flex items-center justify-center
                                        transition"
                      @click="like(index)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 hover:fill-white">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
            </svg>
          </button>
        </span> -->
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import sharingService from '@/services/sharing.service';

const props = defineProps({
  title: String,
  description: String,
  image: String,
  url: String,
  tags: Array,
  // open: {
  //   type: Boolean,
  //   default: false
  // }
})

const open = ref(false)
const popoverRef = ref(null)
const btnRef = ref(null)
const style = ref({})

// const facebookIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
//                         <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
//                       </svg>`
// const instagramIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
//                         <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
//                       </svg>`
// const whatsAppIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
//                         <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
//                       </svg>`


// const options = [
//   { 
//     image: facebookIcon,
//     label: 'Facebook', 
//     value: 1 
//   },
//   { 
//     image: instagramIcon,
//     label: 'Instagram', 
//     value: 2 }
//   ,
//   { 
//     image: whatsAppIcon,
//     label: 'WhatsApp', 
//     value: 3 }
// ]

// const toggle = async () => {
//   open.value = !open.value
//    if (open.value) {
//     await nextTick()
//     positionMenu()
//   }
// }

// const positionMenu = () => {
//   const rect = btnRef.value.getBoundingClientRect()
//   style.value = {
//     top: `${rect.bottom+2}px`,
//     left: `${rect.left - 90}px`
//   }
// }

// const select = (option) => {
//   console.log('Selecionado:', option.label)
//   console.log('URL:', props.url)
//   console.log('Título:', props.title)
//   console.log('Descrição:', props.description)

//   const url = sharingService.sharing(option.label, props.url, props.title, props.description);
//   console.log('URL compartilhamento:', url);  
//   window.open(url, '_blank');
//   open.value = false;
// }

// const data = reactive({
//     open: false
// })

// // Fecha ao clicar fora
// const handleClickOutside = (e) => {
//   if (popoverRef.value && !popoverRef.value.contains(e.target)) {
//     open.value = false
//   }
// }

// onMounted(() => {
//   document.addEventListener('click', handleClickOutside)
// })

// onBeforeUnmount(() => {
//   document.removeEventListener('click', handleClickOutside)
// })


// const share = () => {

//   if (navigator.canShare()) {
//     navigator.share({
//       title: data.title,
//       url: data.url,
//       text: data.description,
//       image: new URL(data.image, location.origin).href
//     })
//     .then(() => console.log('Successful share!'))
//     .catch(err => console.error(err));
//   }
// }
// defineExpose({ data, props, share })
defineExpose({ props })

</script>
